var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3968 0.0696897L7.2 5.49016V13.881L8.0976 14.201L6.7452 16.9029C6.59117 17.21 6.50506 17.5467 6.49271 17.89C6.48036 18.2333 6.54205 18.5753 6.67362 18.8927C6.80519 19.2101 7.00354 19.4956 7.25524 19.7297C7.50693 19.9638 7.80608 20.1411 8.1324 20.2496L13.0332 21.881C13.5814 22.0596 14.1755 22.0365 14.7082 21.8161C15.2409 21.5956 15.6772 21.1923 15.9384 20.6787L17.502 17.555L22.3968 19.3015C22.5778 19.366 22.7717 19.3861 22.9621 19.3602C23.1525 19.3342 23.3339 19.263 23.491 19.1525C23.6481 19.0419 23.7764 18.8953 23.8649 18.7249C23.9535 18.5546 23.9998 18.3655 24 18.1735V1.19766C23.9998 1.00569 23.9535 0.816571 23.8649 0.64621C23.7764 0.47585 23.6481 0.32923 23.491 0.218688C23.3339 0.108146 23.1525 0.0369136 22.9621 0.0109848C22.7717 -0.0149439 22.5778 0.00518894 22.3968 0.0696897ZM13.7916 19.6071L8.892 17.9757L10.374 15.0137L15.2244 16.7447L13.7916 19.6071ZM2.4 13.881H4.8V5.49016H2.4C1.0764 5.49016 0 6.56539 0 7.88754V11.4836C0 12.8058 1.0764 13.881 2.4 13.881Z",
    fill: "#5668E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.c891d0b07ab0a09d237e74c54996d9e4.svg";
export { ForwardRef as ReactComponent };